import request from './request';

const cartNotesService = {
  getAll: (params) => request.get('dashboard/admin/cart-notes', { params }),
  create: (data) => request.post('dashboard/admin/cart-notes', data),
  update: (id, data) => request.put(`dashboard/admin/cart-notes/${id}`, data),
};

export default cartNotesService;

